import apiRequest from 'api/apiRequest';
import endpoints from 'api/endpoints';
import { AppBundle } from 'api/optimalprint-sdk.d';
import { HttpMethods } from 'api/types';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { Store } from 'store';
import getLocaleSelector from 'store/app/selector/getLocaleSelector';
import { setRecentlyViewedProductsAction } from 'store/category/slice';

const fetchAndSetRecentlyViewedProductsOperation =
  () => async (dispatch: ThunkDispatch<Store, undefined, AnyAction>, getState: () => Store) => {
    const store = getState();
    const RecentlyViewedProducts = (await apiRequest(
      endpoints.productV1RecentlyViewedList,
      {
        limit: 15,
        locale: getLocaleSelector(store),
      },
      HttpMethods.POST,
      'data',
    )) as AppBundle.Api.Response.Product.V1.RecentlyViewedProductListV1Response;
    dispatch(setRecentlyViewedProductsAction(RecentlyViewedProducts.items));
  };

export default fetchAndSetRecentlyViewedProductsOperation;
